function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 19.8",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.4 3.9h-.8V2.4h-1.4v1.5h-6V2.4H3.7v1.5h-.8c-.8 0-1.5.7-1.5 1.5v10.5c0 .8.7 1.5 1.5 1.5h10.5c.8 0 1.5-.7 1.5-1.5V5.4c0-.8-.7-1.5-1.5-1.5zm0 12H2.9V8.4h10.5v7.5zm0-9H2.9V5.4h10.5v1.5zm-5.2 3H4.4v3.8h3.8V9.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.9 5.4h10.5v1.5H2.9V5.4z",
  opacity: ".3"
}));